import styled from '@emotion/styled';

const fontSizeForTitle = {
  question: '20px',
  toggle: '24px',
  default: '32px'
};

export const Text = styled.p`
  color: ${props => props.theme.color.primary};
  font-size: ${props => fontSizeForTitle[`${props.type}`]};
  font-weight: ${props => props.theme.fontWeight.bold};
  margin-bottom: ${props => props.marginBottom};
`;
